<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-left">
                            <router-link class="btn GeneralLeave-back btnBack" to="/">
							    <font-awesome-icon icon="fa-solid fa-circle-chevron-left" /> Atrás
							</router-link>
                        </div>
						<div class="title">
							<h3>Anuncio</h3>
						</div>
					</div>
                    <div class="itemList-header">
                        <!--<h1>Ver {{ anuncio }}</h1>-->
                        <h1>{{anuncio.attributes.titulo}}</h1>
                        <small><i>{{formatDate(anuncio.attributes.fecha_inicio)}}</i></small>
                        <hr />
                        <h5><i>Resumen: {{anuncio.attributes.resumen}}</i></h5>
                        
                        <img 
							v-if='anuncio.attributes.imagen.data'
							class='img-responsive center-block' 
							style='padding:0% 25% 0% 25%;'
							:src="'https://api-portal-empleado.casi.es/api/anuncio/imagen' + anuncio.attributes.imagen.data.attributes.url" 
						/>
                        <br />
                        <hr />
                        <br />
                        <vue-markdown>{{anuncio.attributes.cuerpo}}</vue-markdown>
                    </div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
    // @ is an alias to /src
    import Encabezado from "@/components/Encabezado.vue";
    import Footer from "@/components/Footer.vue";

    export default {
        name: "DetalleAnticipo",
		components: {
            Encabezado,
            Footer,
        },
		data() { 
			return{}
		},
		mounted() {
			document.body.classList.remove("bg-login");
			document.body.classList.remove("login-page");
		},
		computed:{
            anuncios: function(){
				let anuncios = this.$store.state.anuncios || [];
			
                return (Array.isArray(anuncios))? anuncios : [anuncios];
			},
			anuncio: function(){
                let anuncio = null;

				if (this.anuncios.length > 0){
                    anuncio = this.anuncios.find(anuncio=>{
                        return anuncio.id == this.$route.params.id_anuncio;
                    });
				}

                return anuncio;
			}
		},
        methods:{
            formatDate: function(date) {
                return this.moment(date).format('DD/MM/YYYY');
            }
        }
    };
</script>

<style>
    @import "../assets/styles/home.css";
	ul{
		padding-left:40px;
	}
	
</style>
